import React from 'react';

const Varni2FlyLogo = ({ className = '', size = 'md', variant = 'default' }) => {
  const heights = { sm: 'h-10', md: 'h-14', lg: 'h-20' };
  const textColor = variant === 'light' ? 'text-white' : 'text-gray-900';

  return (
    <div className={`inline-flex items-center gap-3 ${className}`} aria-label="Varni2Fly Thailand DMC">
      <svg viewBox="0 0 80 80" className={`${heights[size]} w-auto`} aria-hidden="true">
        <defs>
          <linearGradient id="v2f-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2D8DB4" />
            <stop offset="55%" stopColor="#3DA0C9" />
            <stop offset="100%" stopColor="#F7945D" />
          </linearGradient>
        </defs>
        {/* Background tile */}
        <rect x="2" y="2" width="76" height="76" rx="16" fill="url(#v2f-grad)" />
        {/* Plane arc */}
        <path
          d="M14 56 Q 40 14 66 56"
          fill="none"
          stroke="white"
          strokeOpacity="0.35"
          strokeWidth="2"
          strokeLinecap="round"
        />
        {/* Small plane glyph */}
        <g transform="translate(40 22) rotate(15)">
          <path
            d="M -10 0 L 10 -3 L 12 0 L 10 3 L -10 0 Z M 2 -3 L 6 -8 L 8 -7 L 5 -2 Z M 2 3 L 6 8 L 8 7 L 5 2 Z"
            fill="white"
          />
        </g>
        {/* 2 monogram */}
        <text
          x="40"
          y="62"
          textAnchor="middle"
          fontFamily="Manrope, sans-serif"
          fontWeight="900"
          fontSize="34"
          fill="white"
          letterSpacing="-1"
        >
          2F
        </text>
      </svg>
      <div className="leading-none">
        <div className={`text-2xl font-extrabold tracking-tight ${textColor}`}>
          <span className="text-[#2D8DB4]">Varni</span>
          <span className="text-[#F7945D]">2</span>
          <span className={textColor}>Fly</span>
        </div>
        <div className={`text-[10px] uppercase tracking-[0.25em] mt-1 ${variant === 'light' ? 'text-white/70' : 'text-gray-500'}`}>
          Thailand · DMC Division
        </div>
      </div>
    </div>
  );
};

export default Varni2FlyLogo;
